import React from 'react';
import { useReplayData } from './hooks/useReplayData';
import ReplayPlayer from './ReplayPlayer';
import ImageGallery from './ImageGallery';

/**
 * Loading state - spinning logo
 */
const LoadingState = () => (
  <div className="w-dvw h-dvh flex items-center justify-center bg-white">
    <h1 className="splashy-logo">Pipeup</h1>
  </div>
);

/**
 * Error state
 */
const ErrorState = ({ message }) => (
  <div className="w-dvw h-dvh flex flex-col items-center justify-center bg-black text-white">
    <div className="text-4xl mb-4">:(</div>
    <div className="text-lg">{message}</div>
  </div>
);

/**
 * Empty state - no short code provided
 */
const EmptyState = () => (
  <div className="w-dvw h-dvh flex flex-col items-center justify-center bg-black text-white">
    <img
      src="/pipeup-logo.svg"
      alt="Pipeup Replay"
      className="w-32 mb-8 opacity-75"
    />
    <div className="text-xl font-bold">Replay</div>
    <div className="text-sm text-gray-400 mt-2">
      Add a short code to the URL to view a replay
    </div>
  </div>
);

/**
 * Main App component
 * Handles routing via URL path: /{shortCode}
 */
function App() {
  // Get short code and view from URL path: /{shortCode} or /{shortCode}/gallery
  const path = window.location.pathname;
  const segments = path.replace(/^\//, '').split('/');
  const shortCode = segments[0] || null;
  const view = segments[1] || null;

  const { data, loading, error } = useReplayData(shortCode);

  if (!shortCode) {
    return <EmptyState />;
  }

  if (loading || error) {
    return <LoadingState />;
  }

  if (!data || !data.posts || data.posts.length === 0) {
    return <ErrorState message="No posts found in this replay" />;
  }

  if (view === 'gallery') {
    return <ImageGallery data={data} />;
  }

  return <ReplayPlayer data={data} />;
}

export default App;
